import { render, staticRenderFns } from "./SelectPayMethod.vue?vue&type=template&id=33fdb9f8&scoped=true"
import script from "./SelectPayMethod.vue?vue&type=script&lang=js"
export * from "./SelectPayMethod.vue?vue&type=script&lang=js"
import style0 from "./SelectPayMethod.vue?vue&type=style&index=0&id=33fdb9f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fdb9f8",
  null
  
)

export default component.exports